import { render, staticRenderFns } from "./FileGalleryItemThumbnail.vue?vue&type=template&id=11328901"
import script from "./FileGalleryItemThumbnail.vue?vue&type=script&lang=js"
export * from "./FileGalleryItemThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports